import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
export const defaults = {
    id: 0,
    addressee: '',
    integration: {
        name: '',
    },
    isSendScopeAvailable: false,
    integrationId: 0,
    token: {
        email: '',
    },
};
const ModelProps = {
    id: types.optional(types.integer, defaults.id),
    integration: types.optional(types.string, ''),
    integrationId: types.optional(types.integer, defaults.integrationId),
    email: types.optional(types.string, defaults.token.email),
    timestamp: types.optional(types.integer, 0),
    uuid: types.optional(types.string, ''),
    freeCredits: types.optional(types.string, ''),
    shouldAskUserToJoinCommunity: types.optional(types.boolean, true),
    showConnectionSuccess: types.optional(types.boolean, false),
    isSendScopeAvailable: types.optional(types.boolean, false),
};
const Compose = types.model(ModelProps).actions(Actions).views(Views);
export default Compose;
